<template>
  <div style="min-height: 750px; font-size: 14px!important;" v-if="d_usrShpBundWdm">

    <b-row style="margin: 0px;">
      <b-col sm="12" lg="3">
        <b-row>
          <b-col sm="12" lg="12">
            <b-row style="margin-bottom: 10px;">
              <b-col sm="12" lg="6"> </b-col>
              <b-col sm="12" lg="6" style="text-align: right;">
                <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
                  <template slot="button-content">
                    {{ StoreLangTranslation.data['process'][StoreLang] }}
                  </template>
                  <b-dropdown-item v-if="d_userShopClientID && (ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']) || ClsUser.f_checkUserAuth([d_userShopClientID + '_shop_admin', d_userShopClientID + '_shop_bundle_add_edit'], 'with_id'))" @click="f_newUserShopBundle()"><i class="fa fa-plus"></i> {{ StoreLangTranslation.data['new_user_shop_bundle'][StoreLang] }} </b-dropdown-item>

                </b-dropdown>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" lg="12">
                <b-form-input id="search" v-model="d_searchText" :placeholder="StoreLangTranslation.data['write_for_filtering'][StoreLang]"></b-form-input>
              </b-col>
            </b-row>
            <div style="overflow-x: hidden; overflow-y: auto; height: 750px;">
              <template v-if="d_loading">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </template>
              <template v-else>
                <b-row v-for="(wdmr_item, wdmr_item_ind) in d_usrShpBundleList" v-if="f_searchUserShopBundle(wdmr_item)" @mouseover="d_hoverIndex = wdmr_item_ind" @mouseleave="d_hoverIndex = ''" :style="wdmr_item.client_id === d_userShopBundleClientID ? 'cursor: pointer; margin: 10px; border-bottom: solid 1px #dcdcdc; background-color: #fffac3;' : 'cursor: pointer; margin: 1px; border-bottom: solid 1px #dcdcdc;'">

                  <b-col sm="12" lg="10">
                    <b-row @click="f_editThisUserShopBundle(wdmr_item.client_id)">
                      <b-col sm="12" lg="12">
                        <strong style="color: #0058ff;">
                          <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['1'] && wdmr_item.data['0']['1']['lang'] && wdmr_item.data['0']['1']['lang'][StoreLang]">
                            <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['1']['lang'][StoreLang] }}</span>
                          </template>
                          <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['1'] && wdmr_item.data['0']['1']['val']">
                            <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['1']['val'] }}</span>
                          </template>
                        </strong>
                      </b-col>
                    </b-row>
                    <b-row @click="f_editThisUserShopBundle(wdmr_item.client_id)">
                      <b-col sm="12" lg="3">
                        <i>
                          <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['0'] && wdmr_item.data['0']['0']['val']['translation']">
                            <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['0']['val']['translation'][StoreLang] }}</span>
                          </template>
                        </i>
                        
                      </b-col>
                      <b-col sm="12" lg="9">
                        <span style="color: seagreen;">
                          <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['10'] && wdmr_item.data['0']['10']['lang'] && wdmr_item.data['0']['10']['lang'][StoreLang]">
                            <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['10']['lang'][StoreLang] }}</span>
                          </template>
                          <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['10'] && wdmr_item.data['0']['10']['val']">
                            <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['10']['val'] }}</span>
                          </template>
                        </span>
                      </b-col>
                    </b-row>
                  
                  </b-col>
                  <b-col sm="12" lg="2">
                    <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
                      <template slot="button-content">
                      </template>
                      <b-dropdown-item v-if="ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']) || ClsUser.f_checkUserAuth([d_userShopClientID + '_shop_admin', d_userShopClientID + '_shop_bundle_add_edit'], 'with_id')" @click="f_goToUserShopBundleDiscountListPage(wdmr_item.client_id)"><i class="fa fa-list"></i> {{ StoreLangTranslation.data['user_shop_discount_list'][StoreLang] }} </b-dropdown-item>
                      <b-dropdown-item v-if="ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']) || ClsUser.f_checkUserAuth([d_userShopClientID + '_shop_admin', d_userShopClientID + '_shop_bundle_add_edit'], 'with_id')" @click="f_goToUserShopBundleAgreementListPage(wdmr_item.client_id)"><i class="fa fa-list"></i> {{ StoreLangTranslation.data['shop_bundle_agreement_list'][StoreLang] }} </b-dropdown-item>
                      <b-dropdown-item v-if="ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']) || ClsUser.f_checkUserAuth([d_userShopClientID + '_shop_admin', d_userShopClientID + '_shop_bundle_add_edit'], 'with_id')" @click="f_agrementView(wdmr_item.client_id)"><i class="fa fa-sign-in"></i> {{ StoreLangTranslation.data['agreement_preview'][StoreLang] }} </b-dropdown-item>
                    </b-dropdown>
                  </b-col>
                </b-row>
              </template>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="12" lg="9">
        <b-tabs>

          <b-tab  :active="d_selectedTab === 'bundle_edit'" @click="d_selectedTab = 'bundle_edit'">
            <template slot="title">
              {{ StoreLangTranslation.data['shop_bundle_record'][StoreLang] }}
            </template>
            <template v-if="d_selectedTab === 'bundle_edit'">
              <shop-bundle-record v-if="d_componentShow" :p_userShopClientID="d_userShopClientID" :p_userShopBundleClientID="d_userShopBundleClientID" :f_userShopBundleList="f_userShopBundleList"></shop-bundle-record>
            </template>

          </b-tab>

          <b-tab v-if="d_userShopBundleClientID" :active="d_selectedTab === 'bundle_product_list'" @click="d_selectedTab = 'bundle_product_list'">
            <template slot="title">
              {{ StoreLangTranslation.data['shop_bundle_product_list'][StoreLang] }}
            </template>
            <template v-if="d_selectedTab === 'bundle_product_list'">
              <shop-bundle-product-list v-if="d_componentShow" :p_userShopClientID="d_userShopClientID" :p_userShopBundleClientID="d_userShopBundleClientID"></shop-bundle-product-list>

            </template>
            
          </b-tab>

          <b-tab  v-if="d_userShopBundleClientID" :active="d_selectedTab === 'bundle_agreement_list'" @click="d_selectedTab = 'bundle_agreement_list'">
            <template slot="title">
              {{ StoreLangTranslation.data['shop_bundle_agreement_list'][StoreLang] }}
            </template>
            <template v-if="d_selectedTab === 'bundle_agreement_list'">
              <shop-bundle-agreement-list v-if="d_componentShow" :p_userShopClientID="d_userShopClientID" :p_userShopBundleClientID="d_userShopBundleClientID"></shop-bundle-agreement-list>

            </template>
            
          </b-tab>


          <b-tab  v-if="d_userShopBundleClientID" :active="d_selectedTab === 'bundle_discount_list'" @click="d_selectedTab = 'bundle_discount_list'">
            <template slot="title">
              {{ StoreLangTranslation.data['shop_bundle_discount_list'][StoreLang] }}
            </template>
            <template v-if="d_selectedTab === 'bundle_discount_list'">
              <shop-bundle-discount-list v-if="d_componentShow" :p_userShopClientID="d_userShopClientID" :p_userShopBundleClientID="d_userShopBundleClientID"></shop-bundle-discount-list>

            </template>
            
          </b-tab>




        </b-tabs>
      </b-col>
    </b-row>
    
    <b-modal v-if="d_agreementModal.show" id="d_agreementModal_show" v-model="d_agreementModal.show" scrollable hide-footer :title="StoreLangTranslation.data['agreement_preview'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <p>
        <b-row>
          <b-col sm="12" lg="12">
            <agreement-view :p_shopData="d_agreementModal.shop_data" :p_bundleData="d_agreementModal.bundle_data"></agreement-view>
          </b-col>
        </b-row>
      </p>
    </b-modal>
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as AgreementView
} from '@/wam/components/widgets/AgreementView';
import {
  default as ShopBundleRecord
} from '@/wam/components/shop/ShopBundleRecord';
import {
  default as ShopBundleProductList
} from '@/wam/components/shop/ShopBundleProductList';
import {
  default as ShopBundleAgreementList
} from '@/wam/components/shop/ShopBundleAgreementList';
import {
  default as ShopBundleDiscountList
} from '@/wam/components/shop/ShopBundleDiscountList';
import { mapGetters } from 'vuex';
export default {
  name: 'ShopBundleManage',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
  }),
  components: {
    AgreementView,
    ShopBundleRecord,
    ShopBundleProductList,
    ShopBundleAgreementList,
    ShopBundleDiscountList,
  },
  props: {
    d_userShopClientID: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      d_loading: false,
      d_userShopBundleClientID: '',
      d_componentShow: false,
      d_selectedTab: 'bundle_edit',
      d_agreementModal: {
        'show': false,
        'shop_data': {},
        'bundle_data': {},
      },
      d_user: '',
      d_hoverIndex: '',
      d_searchText: '',
      d_frontendClientID: '',
      d_frontendList: [],
      d_usrShpBundleList: [],
      d_usrShpBundWdm: '',
      ClsUser: ClsUser,
    };
  },
  created: function () {
    ClsWdm.getLayerWdm('usr_shp_bund').then(resp_wdm_data => { this.d_usrShpBundWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    this.d_userShopClientID = this.$route.query.user_shop_client_id;

    let auth_eligible = false;
    let user_perm_eligible = false;
    let user_perm_eligibleGeneral = false;
    if (this.$route.meta && this.$route.meta.permission && this.$route.meta.permission.length > 0) {
      auth_eligible = ClsUser.f_checkUserAuth(this.$route.meta.permission, 'without_id');
      if (auth_eligible) {
        user_perm_eligible = ClsUser.f_checkUserAuth([this.d_userShopClientID + '_shop_admin', this.d_userShopClientID + '_shop_bundle_add_edit'],'with_id');
        user_perm_eligibleGeneral = ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']);
      }
    }
    if (this.d_user && this.d_user.username && auth_eligible && (user_perm_eligible || user_perm_eligibleGeneral) ) {
      this.f_userShopBundleList();
    } else {
      this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    }
  },
  beforeMount () {},
  mounted: function () {
    // console.log(this.StoreFrontendSettings);
    // console.log(this.d_usrShpBundWdm);
  },
  methods: {
    f_agrementView: function (user_shop_bundle_client_id) {
      this.d_agreementModal.shop_data = {'client_id': this.d_userShopClientID };
      this.d_agreementModal.bundle_data = {'client_id': user_shop_bundle_client_id, 'agreement_client_id': '' };
      this.d_agreementModal.show = true;
    },
    f_newUserShopBundle: function () {
      this.d_selectedTab = 'bundle_edit';
      this.d_userShopBundleClientID = '';
      this.d_componentShow = false;
      setTimeout(function () {
        this.d_componentShow = true;
      }.bind(this), 100)
      // this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_bundle_record', this.StoreLang), query: {'user_shop_client_id': this.d_userShopClientID} });
    },
    f_goToUserShopBundleProductListPage: function (user_shop_bundle_client_id) {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_bundle_product_list', this.StoreLang), query: {'user_shop_client_id': this.d_userShopClientID, 'user_shop_bundle_client_id': user_shop_bundle_client_id} });
    },
    f_goToUserShopBundleDiscountListPage: function (user_shop_bundle_client_id) {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_bundle_discount_list', this.StoreLang), query: {'user_shop_client_id': this.d_userShopClientID, 'user_shop_bundle_client_id': user_shop_bundle_client_id} });
    },
    f_goToUserShopBundleAgreementListPage: function (user_shop_bundle_client_id) {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_bundle_agreement_list', this.StoreLang), query: {'user_shop_client_id': this.d_userShopClientID, 'user_shop_bundle_client_id': user_shop_bundle_client_id} });
    },
    f_editThisUserShopBundle: function (user_shop_bundle_client_id) {
      this.d_userShopBundleClientID = user_shop_bundle_client_id;
      this.d_componentShow = false;
      setTimeout(function () {
        this.d_componentShow = true;
      }.bind(this), 100)

      // let route_path = ClsRoute.f_getRoutePath('user_shop_bundle_record', this.StoreLang);
      // // console.log('route_path : ', route_path);
      // this.$router.push({ path: route_path, query: { 'user_shop_bundle_client_id': user_shop_bundle_client_id, 'user_shop_client_id': this.d_userShopClientID } });
    },
    f_searchUserShopBundle: function (usr_shp_bund) {
      let res = false;
      if (this.d_searchText) {
        let search_item = '';
        try {
          search_item = usr_shp_bund.data['0']['1']['lang'][this.StoreLang];
        } catch(err) {}
        if (search_item) {
          if (search_item.toLocaleLowerCase().indexOf(this.d_searchText.toLocaleLowerCase()) !== -1) {
            res = true;
          }
        }
      } else {
        res = true;
      }
      return res;
    },
    f_userShopBundleList: function () {
      this.d_componentShow = false;
      this.d_loading = true;
      let query = 'user_client_id=' + this.d_user.username;
      query += '&user_shop_client_id=' + this.d_userShopClientID;
      let data = {};
      ServiceFunctions.user_shop_bundle_list(query, data)
        .then(resp => {
          this.d_componentShow = true;
          this.d_loading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              this.d_usrShpBundleList = resp.data.list;
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
  },
  watch: {
  }
};

</script>

